<template>
  <v-row no-gutters justify="center">
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="controlValue.showLayout"
      :float-layout="controlValue.floatLayout"
      :enable-download="controlValue.enableDownload"
      :preview-modal="controlValue.previewModal"
      :filename="controlValue.filename"
      :paginate-elements-by-height="controlValue.paginateElementsByHeight"
      :pdf-quality="controlValue.pdfQuality"
      :pdf-format="controlValue.pdfFormat"
      :pdf-orientation="controlValue.pdfOrientation"
      :pdf-content-width="controlValue.pdfContentWidth"
      :manual-pagination="controlValue.manualPagination"
      :html-to-pdf-options="htmlToPdfOptions"
    >
      <pdf-content slot="pdf-content" :datas="datas" />
    </vue-html2pdf>
    <v-card rounded="xl" elevation="16" width="100%">
      <v-card-text class="pb-0 mb-0">
        <pdf-content slot="pdf-content" :datas="datas" />
      </v-card-text>
      <v-card-actions class="pa-0 ma-0">
        <v-btn
          large
          block
          color="primary"
          class="btn rounded-b-xl download-text"
          @click="downloadPdf()"
        >
          {{ $t("thanks.download_receipt") }}
          <v-icon large right class="pl-7" v-text="'mdi-cloud-download'" />
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import PdfContent from "./PdfContent.vue";

export default {
  name: "ReceiptPdf",
  components: {
    PdfContent,
  },
  props: {
    datas: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    contentRendered: false,
    progress: 0,
    generatingPdf: false,
    pdfDownloaded: false,
    controlValue: {
      showLayout: false,
      floatLayout: true,
      enableDownload: true,
      previewModal: true,
      paginateElementsByHeight: 1100,
      manualPagination: false,
      filename: "",
      pdfQuality: 2,
      pdfFormat: "a4",
      pdfOrientation: "portrait",
      pdfContentWidth: "800px",
    },
  }),
  computed: {
    htmlToPdfOptions() {
      return {
        margin: 0,
        filename: this.datas.orderRef + ".pdf",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        enableLinks: true,
        html2canvas: {
          scale: this.controlValue.pdfQuality,
          useCORS: true,
        },
        jsPDF: {
          unit: "in",
          format: this.controlValue.pdfFormat,
          orientation: this.controlValue.pdfOrientation,
        },
      };
    },
  },
  methods: {
    async downloadPdf() {
      if (!this.validateControlValue()) return;
      this.$refs.html2Pdf.generatePdf();
    },
    validateControlValue() {
      if (this.controlValue.pdfQuality > 2) {
        // alert("pdf-quality value should only be 0 - 2");
        this.controlValue.pdfQuality = 2;
        return false;
      }
      if (!this.controlValue.paginateElementsByHeight) {
        // alert("paginate-elements-by-height value cannot be empty");
        this.controlValue.paginateElementsByHeight = 1400;
        return false;
      }
      const paperSizes = [
        "a0",
        "a1",
        "a2",
        "a3",
        "a4",
        "letter",
        "legal",
        "a5",
        "a6",
        "a7",
        "a8",
        "a9",
        "a10",
      ];
      if (!paperSizes.includes(this.controlValue.pdfFormat)) {
        console.warn(`pdf-format value should only be ${paperSizes}`);
        this.controlValue.pdfFormat = "a4";
        return false;
      }
      if (!this.controlValue.pdfOrientation) {
        console.warn("pdf-orientation value cannot be empty");
        this.controlValue.pdfOrientation = "portrait";
        return false;
      }
      if (!this.controlValue.pdfContentWidth) {
        console.warn("pdf-content-width value cannot be empty");
        this.controlValue.pdfContentWidth = "800px";
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.download-text {
  font-size: 1rem !important;
  font-weight: 800;
}
</style>
